import { initialState as commonInitialState } from './common'
import type { IWidgetInitialState } from './types'

export const initialState: IWidgetInitialState = {
  ...commonInitialState,
  params: {},
  fromCohortParams: {},
  initialParams: {},
  fetchedParams: {},
  experimentParams: {},
  widgetParams: {},
  urlParams: {},
  embedConfigParams: {},
  videos: {},
  liveStreams: {},
  navigation: [],
  placeholders: [],
  loading: false,
  loaded: false,
  error: null,
  muted: true,
  engagedVideoId: null,
  engagedVideoIdV2: null,
  subtitlesEnabled: false,
  currentSubtitlesId: null,
  subtitlesLanguage: null,
  subtitlesMode: 'cues',
  autoCCMessageShown: false,
  interruptionCallbacks: {},
}
